import * as React from 'react'
import tw, {css} from 'twin.macro'
const Container = ({children, ...rest}) => (
  <div tw="container mx-auto px-6 lg:px-0 " {...rest}>
    {children}
  </div>
)

export default Container
